import React from 'react';
import styles from './AppBar.module.css';

const AppBarMobile = ({ onNavigate, activePage }) => {

  return (
    <header className={styles.appBar}>
      {activePage !== 'home' && (
        <button onClick={() => onNavigate('home')} className={styles.logoLink}>
          <img src="/logo.png" alt="Home" className={styles.logo} color='transparent'/>
        </button>
      )}

      <nav className={styles.nav}>
        <ul>
          <li>
            <button onClick={() => onNavigate('who-we-are')}>Who we are</button>
          </li>
          <li>
            <button onClick={() => onNavigate('how-it-works')}>How it works</button>
          </li>
        </ul>
        <ul>
          <li>
            <button onClick={() => onNavigate('safety-tips')}>Safety tips</button>
          </li>
          <li>
            <button onClick={() => onNavigate('community-guidelines')}>Community guidelines</button>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default AppBarMobile;
